import { render } from "./SortPage.vue?vue&type=template&id=c0d6efd8&scoped=true"
import script from "./SortPage.vue?vue&type=script&lang=js"
export * from "./SortPage.vue?vue&type=script&lang=js"

import "./SortPage.vue?vue&type=style&index=0&id=c0d6efd8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d6efd8"]])

export default __exports__